// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__XrYXd","Wrapper":"Footer_Wrapper__G6L0r","Logo":"Footer_Logo__eZ8Wa"};